/**
 * Component: Base
 * ------------------------------------------------------------------------------
 * IMPORTANT: This is the legacy entry-file for site-wide components,
 * based off Shopify's Slate.
 * - Some of it is unused, some of it is still used but due to be replaced.
 * - New code should not be added to this file and/or section without good
 *   reason.
 * - The general aim should be to remove items from this file, not add to it.
 */

window.theme = window.theme || {}

import CustomerTemplates from './core-theme/ThemecustomerTemplates'
import ThemeSlick from './core-theme/ThemeSlick'

theme.init = function () {
  theme.customerTemplates.init()
}

document.addEventListener('DOMContentLoaded', function () {
  theme.ThemeSlick().init()

  // Check if jQuery is loaded on window
  if (window.jQuery) {
    $(theme.init)
  }
  /**
   * Screen has been resized.
   */
  mint.EventBus.on('mint:resize', (response) => {
    theme.ThemeSlick().init()
  })
})
